"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createContactInfoEditDialog = createContactInfoEditDialog;
var _dialog = require("../../ui/dialog");
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
require("solid-ui/components/forms/select");
require("../../styles/EditDialogs.css");
require("./ContactInfoEditDialog.css");
var _mutations = require("./mutations");
var _phoneCountries = require("../shared/phoneCountries");
var _contactTypeUtils = require("../shared/contactTypeUtils");
var _rowState = require("../shared/rowState");
var _textUtils = require("../../textUtils");
var _texts = require("../../texts");
var _sanitizeUtils = require("../shared/sanitizeUtils");
var _profileIcons = require("../../icons-svg/profileIcons");
var _contactIcons = require("../../icons-svg/contactIcons");
/* Some of the code in this file was generated by AI Model: GPT-5.3-Codex  */
/* Prompt: 1. are you able to create a little trash can icon at the end of 
              each entry so for each phone, email and address line.
           2. are you able to add all the country flags and prefix next to 
              the phone numbers? 
           3. can you write functions to sanitize the input values for emails, phones, and addresses? */

const PHONE_TYPE_OPTIONS = [{
  label: 'Mobile',
  value: 'Cell'
}, {
  label: 'Home',
  value: 'Home'
}, {
  label: 'Work',
  value: 'Work'
}];
const EMAIL_TYPE_OPTIONS = [{
  label: 'Personal',
  value: 'Home'
}, {
  label: 'Office',
  value: 'Office'
}];
function normalizeContactTypeValue(value, options) {
  return options.some(option => option.value === value) ? value : options[0]?.value || '';
}
function readContactTypeChange(event) {
  const customEvent = event;
  if (typeof customEvent.detail?.value === 'string') {
    return customEvent.detail.value;
  }
  const target = event.target;
  return typeof target?.value === 'string' ? target.value : '';
}
function getContactTypeOptions(kind) {
  return kind === 'phone' ? PHONE_TYPE_OPTIONS : EMAIL_TYPE_OPTIONS;
}
function getContactTypeValue(kind, formState, rowIndex) {
  const row = kind === 'phone' ? formState.phones[rowIndex] : formState.emails[rowIndex];
  return normalizeContactTypeValue(row?.type || '', getContactTypeOptions(kind));
}
function withDefaultContactType(row, kind) {
  return {
    ...row,
    type: normalizeContactTypeValue(row.type || '', getContactTypeOptions(kind))
  };
}
function initializeContactTypeSelects(form, formState) {
  const selectElements = form.querySelectorAll('solid-ui-select[data-contact-type-kind]');
  selectElements.forEach(selectElement => {
    const kind = selectElement.dataset.contactTypeKind;
    const rowIndex = Number(selectElement.dataset.rowIndex);
    if (!kind || Number.isNaN(rowIndex)) return;
    selectElement.options = getContactTypeOptions(kind);
    selectElement.value = getContactTypeValue(kind, formState, rowIndex);
    selectElement.label = '';
  });
}
function isContactPointRow(row) {
  return 'value' in row;
}
function rowHasContent(row) {
  if (isContactPointRow(row)) {
    return (0, _textUtils.hasNonEmptyText)(row.value);
  }
  return [row.streetAddress, row.locality, row.region, row.postalCode, row.countryName].some(_textUtils.hasNonEmptyText);
}
function toFormState(contactInfo) {
  const emails = (contactInfo.emails || []).map(email => ({
    value: (0, _sanitizeUtils.sanitizeEmailValue)((0, _textUtils.toText)(email.valueNode).replace(/^mailto:/i, '')),
    type: normalizeContactTypeValue((0, _contactTypeUtils.normalizeEmailTypeForContactInfoEdit)(email.type), EMAIL_TYPE_OPTIONS),
    entryNode: (0, _textUtils.toText)(email.entryNode),
    status: (0, _textUtils.toText)(email.entryNode) ? 'existing' : 'new'
  })).filter(email => Boolean(email.value || email.entryNode || email.type));
  const phones = (contactInfo.phones || []).map(phone => ({
    value: (0, _textUtils.sanitizeTextValue)((0, _textUtils.toText)(phone.valueNode).replace(/^tel:/i, '')),
    type: normalizeContactTypeValue((0, _contactTypeUtils.normalizePhoneTypeForContactInfoEdit)(phone.type), PHONE_TYPE_OPTIONS),
    entryNode: (0, _textUtils.toText)(phone.entryNode),
    status: 'existing'
  })).filter(phone => Boolean(phone.value));
  const addresses = (contactInfo.addresses || []).map(address => ({
    streetAddress: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(address.streetAddress)),
    locality: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(address.locality)),
    region: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(address.region)),
    postalCode: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(address.postalCode)),
    countryName: (0, _sanitizeUtils.sanitizeAddressFieldValue)((0, _textUtils.toText)(address.countryName)),
    type: (0, _textUtils.toText)(address.type),
    entryNode: (0, _textUtils.toText)(address.entryNode),
    status: (0, _textUtils.toText)(address.entryNode) ? 'existing' : 'new'
  })).filter(address => rowHasContent(address) || Boolean(address.entryNode || address.type));
  return {
    emails: emails.length ? emails : [{
      value: '',
      type: EMAIL_TYPE_OPTIONS[0].value,
      entryNode: '',
      status: 'new'
    }],
    phones: phones.length ? phones : [{
      value: '',
      type: PHONE_TYPE_OPTIONS[0].value,
      entryNode: '',
      status: 'new'
    }],
    addresses: addresses.length ? addresses : [{
      streetAddress: '',
      locality: '',
      region: '',
      postalCode: '',
      countryName: '',
      type: '',
      entryNode: '',
      status: 'new'
    }]
  };
}
function renderContactPhoneInputRow({
  phones,
  index,
  displayIndex,
  onDelete
}) {
  const phoneRow = phones[index];
  const label = `Phone Number ${displayIndex + 1}`;
  const typeLabel = `Phone Type ${displayIndex + 1}`;
  const inputName = `phone-value-${index}`;
  const splitValue = (0, _phoneCountries.splitPhoneValue)(phoneRow?.value || '');
  let selectedDialCode = splitValue.dialCode;
  const handleValueInput = e => {
    const target = e.target;
    const nextValue = (0, _sanitizeUtils.sanitizePhoneLocalValue)(target.value);
    if (phones[index]) {
      (0, _rowState.applyRowFieldChange)(phones[index], 'value', (0, _phoneCountries.combinePhoneValue)(selectedDialCode, nextValue), rowHasContent);
    }
  };
  const handleTypeInput = e => {
    const nextType = readContactTypeChange(e);
    if (phones[index]) {
      (0, _rowState.applyRowSelectChange)(phones[index], 'type', nextType);
    }
  };
  const handleDelete = event => {
    event.preventDefault();
    onDelete();
  };
  return (0, _litHtml.html)`
    <div class="profile-edit-dialog__row profile-edit-dialog__row--contact-point">
      <div class="profile-edit-dialog__field">
        <label aria-label=${label} class="label">
          <input
            class="input"
            type="tel"
            name=${inputName}
            .value=${splitValue.localNumber}
            required
            data-contact-field="value"
            data-entry-node=${phoneRow?.entryNode || ''}
            data-row-status=${phoneRow?.status || 'n/a'}
            placeholder=${label}
            autocomplete="tel-national"
            inputmode="tel"
            @input=${handleValueInput}
          />
        </label>
      </div>
      <label aria-label=${typeLabel} class="label profile-edit-dialog__field-type profile-edit-dialog__phone-type-row">
        <solid-ui-select
          class="profile-edit-dialog__type-select"
          id=${`phone-type-select-${inputName}`}
          data-contact-type-kind="phone"
          data-row-index=${String(index)}
          aria-label=${typeLabel}
          .label=${''}
          .options=${PHONE_TYPE_OPTIONS}
          .value=${normalizeContactTypeValue(phoneRow?.type || '', PHONE_TYPE_OPTIONS)}
          @change=${handleTypeInput}
        ></solid-ui-select>
      </label>
      <div class="profile-edit-dialog__actions">
        <solid-ui-button
          type="button"
          variant="icon"
          size="md"
          class="profile-edit-dialog__delete-button"
          aria-label=${`Delete phone number ${displayIndex + 1}`}
          title=${_texts.deleteEntryButtonTitleText}
          @click=${handleDelete}
        >
          <span slot="icon" class="profile-edit-dialog__delete-icon" aria-hidden="true">${_profileIcons.trashIcon}</span>
        </solid-ui-button>
      </div>
    </div>
  `;
}
function renderContactInfoPhoneSection(phones, onAddRow) {
  const createNewRow = event => {
    event.preventDefault();
    phones.unshift({
      value: '',
      type: PHONE_TYPE_OPTIONS[0].value,
      entryNode: '',
      status: 'new'
    });
    onAddRow({
      focusSelector: '[name="phone-value-0"]'
    });
  };
  const visiblePhones = phones.map((phone, index) => ({
    phone,
    index
  })).filter(({
    phone
  }) => phone.status !== 'deleted');
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="phone-numbers-heading" 
      class="profile-edit-dialog__section">
      <header class="profile__section-header profile-edit-dialog__contact-section-header">
        <h3 id="phone-numbers-heading" class="profile-edit-dialog__section-heading">
          <span class="profile-edit-dialog__section-title-icon" aria-hidden="true">${_contactIcons.phoneIcon}</span>
          Phone Numbers
        </h3>
        <solid-ui-button
          type="button"
          variant="secondary"
          size="sm"
          class="profile__action-button profile-action-text profile-edit-dialog__add-button"
          aria-label="Add another phone number"
          @click=${createNewRow}
        >
          <span class="profile__add-more-content">
            <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
            <span>Add More</span>
          </span>
        </solid-ui-button>
      </header>
      <fieldset>
        <legend class="sr-only">Phone number entries</legend>
        ${visiblePhones.map(({
    index
  }, displayIndex) => renderContactPhoneInputRow({
    phones,
    index,
    displayIndex,
    onDelete: () => {
      (0, _rowState.deleteRow)(phones, index);
      onAddRow();
    }
  }))}
      </fieldset>
    </section>
  `;
}
function renderContactEmailInputRow({
  emails,
  index,
  displayIndex,
  onDelete
}) {
  const emailRow = emails[index];
  const label = `Email Address ${displayIndex + 1}`;
  const typeLabel = `Email Type ${displayIndex + 1}`;
  const inputName = `email-value-${index}`;
  const handleValueInput = e => {
    const target = e.target;
    const nextValue = (0, _sanitizeUtils.sanitizeEmailValue)(target.value);
    if (emails[index]) {
      (0, _rowState.applyRowFieldChange)(emails[index], 'value', nextValue, rowHasContent);
    }
  };
  const handleTypeInput = e => {
    const nextType = readContactTypeChange(e);
    if (emails[index]) {
      (0, _rowState.applyRowSelectChange)(emails[index], 'type', nextType);
    }
  };
  const handleDelete = event => {
    event.preventDefault();
    onDelete();
  };
  return (0, _litHtml.html)`
    <div class="profile-edit-dialog__row profile-edit-dialog__row--contact-point">
      <label aria-label=${label} class="label profile-edit-dialog__field">
        <input
          class="input"
          type="email"
          name=${inputName}
          .value=${emailRow?.value || ''}
          required
          data-contact-field="value"
          data-entry-node=${emailRow?.entryNode || ''}
          data-row-status=${emailRow?.status || 'n/a'}
          placeholder="Email Address"
          autocomplete="email"
          inputmode="email"
          @input=${handleValueInput}
        />
      </label>
      <label aria-label=${typeLabel} class="label profile-edit-dialog__field-type emailTypeRow">
        <solid-ui-select
          class="profile-edit-dialog__type-select"
          id=${`email-type-select-${inputName}`}
          data-contact-type-kind="email"
          data-row-index=${String(index)}
          aria-label=${typeLabel}
          .label=${''}
          .options=${EMAIL_TYPE_OPTIONS}
          .value=${normalizeContactTypeValue(emailRow?.type || '', EMAIL_TYPE_OPTIONS)}
          @change=${handleTypeInput}
        ></solid-ui-select>
      </label>
      <div class="profile-edit-dialog__actions">
        <solid-ui-button
          type="button"
          variant="icon"
          size="md"
          class="profile-edit-dialog__delete-button"
          aria-label=${`Delete email address ${displayIndex + 1}`}
          title=${_texts.deleteEntryButtonTitleText}
          @click=${handleDelete}
        >
          <span slot="icon" class="profile-edit-dialog__delete-icon" aria-hidden="true">${_profileIcons.trashIcon}</span>
        </solid-ui-button>
      </div>
    </div>
  `;
}
function renderContactInfoEmailSection(emails, onAddRow) {
  const createNewRow = event => {
    event.preventDefault();
    emails.unshift({
      value: '',
      type: EMAIL_TYPE_OPTIONS[0].value,
      entryNode: '',
      status: 'new'
    });
    onAddRow({
      focusSelector: '[name="email-value-0"]'
    });
  };
  const visibleEmails = emails.map((email, index) => ({
    email,
    index
  })).filter(({
    email
  }) => email.status !== 'deleted');
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="email-addresses-heading" 
      class="profile-edit-dialog__section">
      <header class="profile__section-header profile-edit-dialog__contact-section-header">
        <h3 id="email-addresses-heading" class="profile-edit-dialog__section-heading">
          <span class="profile-edit-dialog__section-title-icon" aria-hidden="true">${_contactIcons.emailIcon}</span>
          Email Addresses
        </h3>
        <solid-ui-button
          type="button"
          variant="secondary"
          size="sm"
          class="profile__action-button profile-action-text profile-edit-dialog__add-button"
          aria-label="Add another email address"
          @click=${createNewRow}
        >
          <span class="profile__add-more-content">
            <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
            <span>Add More</span>
          </span>
        </solid-ui-button>
      </header>
      <fieldset>
        <legend class="sr-only">Email address entries</legend>
        ${visibleEmails.map(({
    index
  }, displayIndex) => renderContactEmailInputRow({
    emails,
    index,
    displayIndex,
    onDelete: () => {
      (0, _rowState.deleteRow)(emails, index);
      onAddRow();
    }
  }))}
      </fieldset>
    </section>
  `;
}
function renderContactAddressInputRow({
  addresses,
  index,
  displayIndex,
  onDelete
}) {
  const addressRow = addresses[index];
  const label = `Address ${displayIndex + 1}`;
  const typeLabel = `Address Type ${displayIndex + 1}`;
  const streetAddressName = `address-street-${index}`;
  const localityName = `address-locality-${index}`;
  const regionName = `address-region-${index}`;
  const postalCodeName = `address-postal-${index}`;
  const countryName = `address-country-${index}`;
  const typeInputName = `address-type-${index}`;
  const addressTypeSelectId = `address-type-select-${index}`;
  const handleAddressInput = field => e => {
    const target = e.target;
    const nextValue = (0, _sanitizeUtils.sanitizeAddressFieldValue)(target.value);
    if (addresses[index]) {
      (0, _rowState.applyRowFieldChange)(addresses[index], field, nextValue, rowHasContent);
    }
  };
  const handleTypeInput = e => {
    const target = e.target;
    const nextType = target.value;
    if (addresses[index]) {
      (0, _rowState.applyRowSelectChange)(addresses[index], 'type', nextType);
    }
  };
  const handleDelete = event => {
    event.preventDefault();
    onDelete();
  };
  return (0, _litHtml.html)`
    <div class="profile-edit-dialog__row profile-edit-dialog__row--address-header profile-edit-dialog__row--full">
      <p class="profile-edit-dialog__address-title">${label}</p>
      <label aria-label=${typeLabel} class="label profile-edit-dialog__field-type profile-edit-dialog__field-type--wide hidden">
        Address Type
        <select name=${typeInputName} id=${addressTypeSelectId} @change=${handleTypeInput} .value=${addressRow?.type || ''}>
          <option value="Home">Home</option>
          <option value="Work">Work</option>
        </select>
      </label>
      <div class="profile-edit-dialog__actions profile-edit-dialog__actions--edge">
        <solid-ui-button
          type="button"
          variant="icon"
          size="md"
          class="profile-edit-dialog__delete-button"
          aria-label=${`Delete address ${displayIndex + 1}`}
          title=${_texts.deleteEntryButtonTitleText}
          @click=${handleDelete}
        >
          <span slot="icon" class="profile-edit-dialog__delete-icon" aria-hidden="true">${_profileIcons.trashIcon}</span>
        </solid-ui-button>
      </div>
    </div>
    <div class="profile-edit-dialog__row profile-edit-dialog__row--full">
      <label aria-label=${`${label} Street`} class="label profile-edit-dialog__field profile-edit-dialog__field--full">
        Street Address
        <input
          class="input"
          type="text"
          name=${streetAddressName}
          .value=${addressRow?.streetAddress || ''}
          required
          data-contact-field="streetAddress"
          data-entry-node=${addressRow?.entryNode || ''}
          data-row-status=${addressRow?.status || 'n/a'}
          placeholder="Street Address"
          autocomplete="street-address"
          inputmode="text"
          @change=${handleAddressInput('streetAddress')}
        />
      </label>
    </div>
    <div class="profile-edit-dialog__row profile-edit-dialog__row--full profile-edit-dialog__row--equal">
      <label aria-label=${`${label} Locality`} class="label profile-edit-dialog__field">
        Locality
        <input
          class="input"
          type="text"
          name=${localityName}
          .value=${addressRow?.locality || ''}
          data-contact-field="locality"
          data-entry-node=${addressRow?.entryNode || ''}
          data-row-status=${addressRow?.status || 'n/a'}
          placeholder="City / Locality"
          autocomplete="address-level2"
          inputmode="text"
          @change=${handleAddressInput('locality')}
        />
      </label>
      <label aria-label=${`${label} Postal Code`} class="label profile-edit-dialog__field">
        Postal Code
        <input
          class="input"
          type="text"
          name=${postalCodeName}
          .value=${addressRow?.postalCode || ''}
          data-contact-field="postalCode"
          data-entry-node=${addressRow?.entryNode || ''}
          data-row-status=${addressRow?.status || 'n/a'}
          placeholder="Postal Code"
          autocomplete="postal-code"
          inputmode="text"
          @change=${handleAddressInput('postalCode')}
        />
      </label>
    </div>

    <div class="profile-edit-dialog__row profile-edit-dialog__row--full profile-edit-dialog__row--equal">
      <label aria-label=${`${label} Region`} class="label profile-edit-dialog__field">
        Region
        <input
          class="input"
          type="text"
          name=${regionName}
          .value=${addressRow?.region || ''}
          data-contact-field="region"
          data-entry-node=${addressRow?.entryNode || ''}
          data-row-status=${addressRow?.status || 'n/a'}
          placeholder="State / Region"
          autocomplete="address-level1"
          inputmode="text"
          @change=${handleAddressInput('region')}
        />
      </label>
      <label aria-label=${`${label} Country`} class="label profile-edit-dialog__field">
        Country
        <input
          class="input"
          type="text"
          name=${countryName}
          .value=${addressRow?.countryName || ''}
          data-contact-field="countryName"
          data-entry-node=${addressRow?.entryNode || ''}
          data-row-status=${addressRow?.status || 'n/a'}
          placeholder="Country"
          autocomplete="country-name"
          inputmode="text"
          @change=${handleAddressInput('countryName')}
        />
      </label>
    </div>
  `;
}
function renderContactInfoAddressSection(addresses, onAddRow) {
  const createNewRow = event => {
    event.preventDefault();
    addresses.unshift({
      streetAddress: '',
      locality: '',
      region: '',
      postalCode: '',
      countryName: '',
      type: '',
      entryNode: '',
      status: 'new'
    });
    onAddRow({
      focusSelector: '[name="address-street-0"]'
    });
  };
  const visibleAddresses = addresses.map((address, index) => ({
    address,
    index
  })).filter(({
    address
  }) => address.status !== 'deleted');
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="address-heading" 
      class="profile-edit-dialog__section">
      <header class="profile__section-header profile-edit-dialog__contact-section-header">
        <h3 id="address-heading" class="profile-edit-dialog__section-heading">
          <span class="profile-edit-dialog__section-title-icon" aria-hidden="true">${_profileIcons.locationIcon}</span>
          Addresses
        </h3>
        <solid-ui-button
          type="button"
          variant="secondary"
          size="sm"
          class="profile__action-button profile-action-text profile-edit-dialog__add-button"
          aria-label="Add another address"
          @click=${createNewRow}
        >
          <span class="profile__add-more-content">
            <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
            <span>Add More</span>
          </span>
        </solid-ui-button>
      </header>
      <fieldset>
        <legend class="sr-only">Address entries</legend>
        ${visibleAddresses.map(({
    index
  }, displayIndex) => renderContactAddressInputRow({
    addresses,
    index,
    displayIndex,
    onDelete: () => {
      (0, _rowState.deleteRow)(addresses, index);
      onAddRow();
    }
  }))}
      </fieldset>
    </section>
  `;
}
function focusContactInfoField(form, selector) {
  const nextField = form.querySelector(selector);
  if (!nextField || typeof nextField.focus !== 'function') return;
  const view = form.ownerDocument.defaultView;
  const shouldAvoidFocus = Boolean(view?.matchMedia && (view.matchMedia('(pointer: coarse)').matches || view.matchMedia('(max-width: 640px)').matches));
  if (shouldAvoidFocus) {
    nextField.scrollIntoView({
      block: 'nearest',
      behavior: 'auto'
    });
    return;
  }
  nextField.scrollIntoView({
    block: 'nearest',
    behavior: 'auto'
  });
  nextField.focus();
  if (nextField instanceof HTMLInputElement || nextField instanceof HTMLTextAreaElement) {
    nextField.select();
  }
}
function renderContactInfoEditTemplate(form, formState, viewerMode, options = {}) {
  const rerender = (nextOptions = {}) => renderContactInfoEditTemplate(form, formState, viewerMode, nextOptions);
  (0, _litHtml.render)((0, _litHtml.html)`
    ${renderContactInfoPhoneSection(formState.phones, rerender)}
    ${renderContactInfoEmailSection(formState.emails, rerender)}
    ${renderContactInfoAddressSection(formState.addresses, rerender)}
    ${viewerMode !== 'owner' ? (0, _litHtml.html)`<p class="profile-edit-dialog__login-message">${_texts.ownerLoginRequiredDialogMessageText}</p>` : null}
  `, form);
  initializeContactTypeSelects(form, formState);
  if (options.focusSelector) {
    focusContactInfoField(form, options.focusSelector);
  }
}
function createContactInfoEditForm(contactInfo, viewerMode) {
  const form = document.createElement('form');
  form.classList.add('profile__edit-form');
  form.classList.add('profile__edit-form--contact-info');
  const formState = toFormState(contactInfo);
  renderContactInfoEditTemplate(form, formState, viewerMode);
  return {
    form,
    formState
  };
}
function isValidEmailAddress(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
function isValidPhoneNumber(value) {
  return /^\d+$/.test(value);
}
function validateContactInfoBeforeSave(formState) {
  const visiblePhones = formState.phones.filter(phone => phone.status !== 'deleted');
  for (const [index, phone] of visiblePhones.entries()) {
    if (!rowHasContent(phone)) continue;
    const {
      localNumber
    } = (0, _phoneCountries.splitPhoneValue)(phone.value || '');
    if (!isValidPhoneNumber(localNumber)) {
      return `Phone Number ${index + 1} should contain only numbers.`;
    }
  }
  const visibleEmails = formState.emails.filter(email => email.status !== 'deleted');
  for (const [index, email] of visibleEmails.entries()) {
    if (!rowHasContent(email)) continue;
    if (!isValidEmailAddress(email.value || '')) {
      return `Email address ${index + 1} must be a valid email address.`;
    }
  }
  return null;
}
async function createContactInfoEditDialog(event, store, subject, contactInfo, viewerMode, onSaved) {
  const dom = event.currentTarget?.ownerDocument || document;
  const {
    form,
    formState
  } = createContactInfoEditForm(contactInfo, viewerMode);
  const result = await (0, _dialog.openInputDialog)({
    title: _texts.editContactInfoDialogTitleText,
    dom,
    form,
    headerAction: {
      type: 'close'
    },
    submitLabel: _texts.dialogSubmitLabelText,
    cancelLabel: _texts.dialogCancelLabelText,
    shouldCloseWithoutSave: () => {
      const phoneOps = (0, _rowState.summarizeRowOps)(formState.phones, rowHasContent);
      const emailOps = (0, _rowState.summarizeRowOps)(formState.emails, rowHasContent);
      const addressOps = (0, _rowState.summarizeRowOps)(formState.addresses, rowHasContent);
      return phoneOps.create.length === 0 && phoneOps.update.length === 0 && phoneOps.remove.length === 0 && emailOps.create.length === 0 && emailOps.update.length === 0 && emailOps.remove.length === 0 && addressOps.create.length === 0 && addressOps.update.length === 0 && addressOps.remove.length === 0;
    },
    validate: () => {
      if (viewerMode !== 'owner') {
        return _texts.ownerLoginRequiredDialogMessageText;
      }
      return validateContactInfoBeforeSave(formState);
    },
    onSave: async () => {
      const phoneOps = (0, _rowState.summarizeRowOps)(formState.phones, rowHasContent);
      const emailOps = (0, _rowState.summarizeRowOps)(formState.emails, rowHasContent);
      const plan = {
        phoneOps: {
          create: phoneOps.create.map(row => withDefaultContactType(row, 'phone')),
          update: phoneOps.update.map(row => withDefaultContactType(row, 'phone')),
          remove: phoneOps.remove
        },
        emailOps: {
          create: emailOps.create.map(row => withDefaultContactType(row, 'email')),
          update: emailOps.update.map(row => withDefaultContactType(row, 'email')),
          remove: emailOps.remove
        },
        addressOps: (0, _rowState.summarizeRowOps)(formState.addresses, rowHasContent)
      };
      await (0, _mutations.processContactInfoMutations)(store, subject, plan);
    },
    formatSaveError: error => {
      return error instanceof Error ? error.message : _texts.saveContactUpdatesFailedMessageText;
    }
  });
  if (!result) return;
  if (onSaved) {
    await onSaved();
  }
}